import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import type { DataType, FetchType } from "../../types"
import { useApi, useHandleAuth } from "utils"

export function useList(): { isError: boolean, isLoading: boolean, fetchData: () => Promise<DataType> } {
  const api = useApi() 
  const auth = useHandleAuth()
  const token = auth?.userTokenData()
  const [isError, setError] = useState<boolean>(false)
  const [isLoading, setLoading] = useState<boolean>(true)

  const fetchData = (): Promise<DataType> => {
    return new Promise<DataType>((resolve) => {
      setLoading(true)

      api
        .get("/settingcompany/")
        .then(
          (
            res: SuccessFetch<{
              payload: FetchType[]
            }>
          ) => {
            // Vars
            const payload = res.data.payload[0]

            resolve({
              company_code: token?.company_code ?? "",
              company_name: token?.company_name ?? "-",
              subdomain: token?.subdomain ?? "-",
              address: payload.address?.toString() ?? "",
              barcode_type: payload.barcode_type?.toString() ?? "",
              country_id: payload.country_id?.toString() ?? "",
              email: payload.email?.toString() ?? "",
              finance_year: payload.finance_year?.toString() ?? "",
              methode_avg_price: payload.methode_avg_price?.toString() ?? "",
              mobile_phone: payload.mobile_phone?.toString() ?? "",
              phone: payload.phone?.toString() ?? "",
              country_name: payload.country_name?.toString() ?? "",
              province_id: payload.province_id?.toString() ?? "",
              province_name: payload.province_name?.toString() ?? "",
              regency_id: payload.regency_id?.toString() ?? "",
              regency_name: payload.regency_name?.toString() ?? "",
              subdistrict_id: payload.subdistrict_id?.toString() ?? "",
              subdistrict_name: payload.subdistrict_name?.toString() ?? "",
              village_id: payload.village_id?.toString() ?? "",
              village_name: payload.village_name?.toString() ?? "",
              website: payload.website?.toString() ?? "",
              period_adjustment: payload.period_adjustment?.toString() ?? "",
              tax: payload.tax ?? null,
              logo_path: payload.logo_path ?? null
            })
          }
        )
        .catch(() => {
          setError(true)
          resolve({
            company_code: "-",
            company_name: "-",
            subdomain: "",
            address: "",
            barcode_type: "",
            country_id: "",
            email: "",
            finance_year: "",
            methode_avg_price: "",
            mobile_phone: "",
            phone: "",
            province_id: "",
            regency_id: "",
            subdistrict_id: "",
            village_id: "",
            website: "",
            period_adjustment: ""
          })
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  return { isError, isLoading, fetchData }
}

export function useGestSingleSettingCompany() {
  const api = useApi()
  const [data, setData] = useState<DataType[] | []>([])
  const [isLoading, setLoading] = useState(true)

  const fetchingData = () => api.get(`/settingcompany/`)

  const fetchData = () => {
    setLoading(true)

    fetchingData()
    .then((res: SuccessFetch<{ payload: DataType[] }>) => { setData(res.data.payload) })
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }
  const refetch = () => fetchData()

  useEffect(() => {
    refetch()

    return () => {
      setData([])
      setLoading(true)
    }
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}
